import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PrescriptionQueueItem from './PrescriptionQueueItem';
import { fetchQueues} from '../../../../ReduxSlices/Prescriptions/prescriptionQueueSlice';
import LoadingDots from '../../../shared/LoadingDots';

const PrescriptionQueueList = () => {

  const dispatch = useDispatch();
  const { queues, loading, error, errorQueueId, errorItems} = useSelector((state) => state.prescriptionQueue);  

  // Fetch initial queues
  useEffect(() => {
    if(queues.length === 0){
    dispatch(fetchQueues());
    }
     }, [dispatch, queues.length]);

  if (loading) return (<LoadingDots height={10} width={30} color="#38AD3E" />);

  return (
    <>    
      <h2>Prescription Queue</h2>
        {queues.length === 0 && <p>No prescriptions in the queue.</p>}

      {queues.length > 0 && (
        <div className="prescription-grid">
          {queues.map((queue) => (
            <div key={queue.id}>
            <PrescriptionQueueItem
              queue={queue}
              error={queue.id === errorQueueId ? error : null}
              medicationError={errorItems}
            />
            </div>
          ))}
        </div>
      )}    

         </>
  );
};

export default PrescriptionQueueList;
